import { render, staticRenderFns } from "./fair-list.vue?vue&type=template&id=57a5efac&scoped=true"
import script from "./fair-list.vue?vue&type=script&lang=js"
export * from "./fair-list.vue?vue&type=script&lang=js"
import style0 from "./fair-list.vue?vue&type=style&index=0&id=57a5efac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a5efac",
  null
  
)

export default component.exports